export { default as formatAsUSD } from './formatAsUSD'
export { default as removeAllNonDigitChar } from './removeAllNonDigitChar'
export { default as generateTheme } from './generateTheme'
